import React from "react";

type Props = {
    label?: string;
};

export const fallbackImage = "https://static.piggy.nl/images/fallback_image.png";

export default function MediaUpload(props: React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> & Props) {
    const image = React.useRef<HTMLImageElement>(null);

    const loadFile = (event: React.ChangeEvent<HTMLInputElement>) => {
        const input = event.target;
        const file = input.files[0];
        image.current.src = URL.createObjectURL(file);
    };

    return (
        <div className="flex items-center space-x-6">
            <div className="shrink-0">
                <img
                    ref={image}
                    className="size-14 rounded-full object-cover"
                    src={fallbackImage}
                    alt={props.label}
                />
            </div>
            <label className="block">
                <span className="sr-only">Choose media</span>
                <input
                    type="file"
                    onChange={e => {
                        loadFile(e)
                        props.onChange(e)
                    }}
                    className="block w-full text-sm text-slate-500 file:mr-4 file:rounded-full file:border-0 file:bg-violet-50 file:px-4
                    file:py-2 file:text-sm file:font-semibold file:text-accentColor file:shadow hover:file:bg-violet-100"
                />
            </label>
        </div>
    );
}